import { useEffect, useState } from 'react';
import { siteNav } from '@/mocks/gua88-site';

export default function StickyNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'bg-background-50/95 border-b border-background-200'
          : 'bg-background-50/0'
      }`}
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 md:px-6">
        {/* brand */}
        <a href="#top" className="group flex items-center gap-2.5" onClick={() => setOpen(false)}>
          <span className="font-display text-2xl leading-none text-primary-500 group-hover:text-primary-600">
            88
          </span>
          <span className="font-heading text-lg font-bold leading-none tracking-tight text-foreground-950">
            吃瓜
          </span>
          <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
            后续专区
          </span>
        </a>

        {/* desktop links */}
        <div className="hidden items-center gap-1 lg:flex">
          {siteNav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap rounded-full px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {n.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            <i className="ri-notification-3-line mr-1.5"></i>
            蹲后续
          </a>
          <button
            type="button"
            aria-label="展开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-full text-lg text-foreground-900 hover:bg-secondary-100 lg:hidden"
          >
            <i className={open ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </nav>

      {/* mobile panel */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="grid grid-cols-2 gap-1">
            {siteNav.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-secondary-100"
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}